import { ColumnConfig, wafflesKeyColumnName } from "@app/shared/waffles";

const SKELETON_BONE = (
  <div className="skeleton shimmer">
    <div className="bone" style={{ borderRadius: 2, height: "1rem" }} />
  </div>
);

export function createSkeletonRows<T>(count: number, columns: ColumnConfig): T[] {
  const skeletonEntries = Object.keys(columns).map(key => [key, SKELETON_BONE]);
  return Array.from({ length: count }, (_, i) =>
    Object.fromEntries([...skeletonEntries, [wafflesKeyColumnName, `skeleton-${i}`], ["id", i]]) as unknown as T
  );
}
